var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9315 4.76756L5.00293 4.68482C5.26484 4.42291 5.67467 4.39911 5.96347 4.61339L6.04621 4.68482L12.4098 11.0481L18.7735 4.68482C19.0616 4.39673 19.5286 4.39673 19.8167 4.68482C20.1048 4.97291 20.1048 5.44 19.8167 5.72809L13.4534 12.0917L19.8167 18.4553C20.0786 18.7172 20.1024 19.127 19.8881 19.4158L19.8167 19.4986C19.5548 19.7605 19.145 19.7843 18.8562 19.57L18.7735 19.4986L12.4098 13.1353L6.04621 19.4986C5.75812 19.7867 5.29102 19.7867 5.00293 19.4986C4.71485 19.2105 4.71485 18.7434 5.00293 18.4553L11.3662 12.0917L5.00293 5.72809C4.74103 5.46619 4.71723 5.05636 4.9315 4.76756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelWhiteIcon);
export default __webpack_public_path__ + "static/media/cancel-white-icon.f22b0ab75fd9055fd592cbf68f7a8ca2.svg";
export { ForwardRef as ReactComponent };